import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app-core/services/common.service';
import { JobsService } from 'src/app/jobs/jobs.service';
import { QuotesService } from 'src/app/quotes/quotes.service';
import { VehiclesService } from 'src/app/vehicles/vehicles.service';
import { CalenderViewTypeEnum } from '../app-common-enum';
import { AppointmentFormComponent } from '../appointment-form/appointment-form.component';
import { AppointmentsTasksCalendarComponent } from '../appointments-tasks-calendar/appointments-tasks-calendar.component';

@Component({
  selector: 'app-orders-appointments-tasks',
  templateUrl: './orders-appointments-tasks.component.html',
  styleUrls: ['./orders-appointments-tasks.component.scss']
})
export class OrdersAppointmentsTasksComponent implements OnInit {

  @ViewChild('AppointmentCalendar', { static: false }) AppointmentCalendar: AppointmentsTasksCalendarComponent;
  isAppointmentsTasksLoading = false;
  showAppointments = true;
  employeeId: number;
  driverId: number;
  orderId: string;
  isQuote: boolean;
  orderDetails: any;
  appointmentFilter: any;
  appointmentTypeFIlter: any;
  calenderViewTypeEnum: typeof CalenderViewTypeEnum = CalenderViewTypeEnum;
  driverList: any;
  // for now hardcoded data
  employees: any;
  appointmentType: any = [
    { label: 'Pickup', type: 'pickup', isActive: false, id: 1 },
    { label: 'Delivery', type: 'delivery', isActive: false, id: 2 },
    { label: 'Survey', type: 'onsite_survey', isActive: false, id: 3 },
    { label: 'Sales', type: 'sales', isActive: false, id: 4 },
    { label: 'Build', type: 'onsite_build', isActive: false, id: 5 }
  ];
  // for now hardcoded data
  isCalendarView = true;
  calendarCurrentView: string;
  editData: any;

  constructor(
    private location: Location,
    private dialog: MatDialog,
    private jobsService: JobsService,
    private quotesService: QuotesService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private vehiclesService: VehiclesService,
    private router: Router,
  ) { }

  ngOnInit() {
    if (this.AppointmentCalendar && this.AppointmentCalendar.currentView) {
      this.calendarCurrentView = this.AppointmentCalendar.currentView;
    }
    if (this.activatedRoute.snapshot.queryParams.jobId) {
      this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
      this.isQuote = false;
    } else {
      this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
      this.isQuote = true;
    }
    this.getOrderDetails();
    this.generateFilter();
    this.getDrivers();
  }

  onAppointmentAdd(isFromCalendar, isEdit: boolean) {
    let params;
    if (isFromCalendar) {
      params = {
        appointmentDetails: {},
        start: this.AppointmentCalendar.timeSlotFromCalendar.start,
        end: this.AppointmentCalendar.timeSlotFromCalendar.end,
        orderDetails: this.orderDetails,
        calendarCurrentView: this.calendarCurrentView,
        appointmentFilter: this.appointmentFilter
      };
    } else {
      params = {
        isEdit,
        appointmentDetails: isEdit ? this.editData : {},
        orderDetails: this.orderDetails,
        appointmentFilter: this.appointmentFilter
      };
    }
    this.dialog.open(AppointmentFormComponent, {
      position: {
        right: '0',
      },
      panelClass: 'small_layout',
      hasBackdrop: false,
      data: params,
      autoFocus: false
    }).afterClosed().subscribe((response: any) => {
      if (response && response.confirmResult === true) {
        this.getOrderDetails();
        this.generateFilter();
      }
    });
  }

  getOrderDetails() {
    if (this.isQuote) {
      this.quotesService.getQuote(this.orderId).subscribe(response => {
        this.orderDetails = response.data;
        this.getEmployees();
      });
    } else {
      this.jobsService.getJob(this.orderId).subscribe(response => {
        this.orderDetails = response.data;
        this.getEmployees();
      });
    }

  }

  getEmployees(): void {
    this.commonService.getEmployees(this.orderDetails.assignedTo || 0).subscribe(response => {
      if (response.isSuccess) {
        this.employees = response.data.filter(employee => employee.includeOnSchedule);
      }
    });
  }

  onAppointmentChange() {
    this.generateFilter();
  }

  emitLoadTimeSlot(data: any) {
    this.calendarCurrentView = this.AppointmentCalendar.currentView;
    this.onAppointmentAdd(true, false);
  }

  emitEditAppointment(data: any) {
    this.editData = data;
    this.onAppointmentAdd(false, true);
  }

  getAppointmentTypeFilter(): any {
    const activeAppointmentTypes = this.appointmentType.filter(item => item.isActive);
    if (activeAppointmentTypes && activeAppointmentTypes.length > 0) {
      return activeAppointmentTypes.map(item => item.id);
    }
    return null;
  }

  employeeChange(event: any) {
    this.employeeId = event.assignedTo;
    this.generateFilter();
  }

  onshowAppointmentsChange(event: any) {
    this.showAppointments = event.value;
    this.generateFilter();
  }

  generateFilter() {
    this.appointmentFilter = {
      isAllJOb: this.showAppointments,
      orderId: this.orderId,
      employeeId: this.employeeId,
      driverId: this.driverId,
      appointmentType: this.getAppointmentTypeFilter(),
    };
  }

  onRedirectToAppointmentPrint(): void {
    // this.router.navigateByUrl('/app/todays-appointment-print');
    this.router.navigate([]).then(result => {  window.open('/app/todays-appointment-print', '_blank'); });
  }

  onGoBack(): void {
    this.location.back();
  }

  getDrivers() {
    this.vehiclesService.getDrivers().subscribe(response => {
      if (response.isSuccess) {
        this.driverList = response.data;
      }
    });
  }

  onDriverChange(data: any) {
    if (data) {
      this.driverId = data.driverId;
      this.generateFilter();
    }
  }
}
